/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskKnowledgeArticleEmbedEditorType from '@jira/spa-apps__servicedesk-knowledge-article-embed-editor/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServiceDeskKnowledgeArticleEmbedEditor: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskKnowledgeArticleEmbedEditorType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-knowledge-hub-embed-editor", jiraSpaEntry: "async-servicedesk-knowledge-hub-embed-editor" */ '@jira/spa-apps__servicedesk-knowledge-article-embed-editor/src/index.tsx'
			),
		),
	);

const AsyncServiceDeskKnowledgeArticleEmbedEditor = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServiceDeskKnowledgeArticleEmbedEditor}
		pageId="knowledge-article-embed-editor"
		shouldShowSpinner
	/>
);

export default AsyncServiceDeskKnowledgeArticleEmbedEditor;
